import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from 'ui';

// «Cerrar» por defecto, que es lo que hace en SyncProgress y Yoy; si hace otra cosa, el consumidor pasa `ariaLabel`.
// Es un <button>: no puede ir dentro de otro botón o enlace.
function CloseMiniButton({ ariaLabel, onClick, size = 'default' }) {
  const { t } = useTranslation();

  return (
    <button aria-label={ariaLabel || t('actions:Close')} className={clsx('close-mini-button', `close-mini-button--${size}`)} onClick={onClick} type="button">
      <Icon name="close" color="white" size={size !== 'default' ? 'big' : 'xs'} />
    </button>
  );
}

CloseMiniButton.propTypes = {
  ariaLabel: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(['default', 'm']),
};

export default CloseMiniButton;
